import type { FaireProductEntity } from "../../entity_types/product";

export const p_u535sa2hg3: FaireProductEntity = {
  token: "p_u535sa2hg3",
  type: "product",
  name: "Aloha L\u0101 H\u0101nau - Greeting Card",
  brandName: "Design Jord",
  imageUrl:
    "https://cdn.faire.com/fastly/622ddb621569e3a9ea27497a5d0d34a6de8a9e42c928432f345b741dbc7e5c60.jpeg",
  priceDollars: 2.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/978570c0dfdaf8951f91dae6e05292197d7f5beb166343971e9e53fe38749918.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
